import {Component, Input} from '@angular/core';

@Component({
    selector: 'mx-thumbnail',
    standalone: false,
    templateUrl: './mx-thumbnail.component.html',
    styleUrls: ['./mx-thumbnail.component.scss']

})
export class MxThumbnailComponent {
    @Input() defaultThumbnailClass: string;
    @Input() thumbnailUrl: string;
    imageLoaded: boolean = false;

    load(): void {
        this.imageLoaded = true;
    }
}
